import{isFunction as r}from"lodash";var t=(t,e)=>{r(t)?t(e.current):t.current=e.current};export{t as m};
